import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DnaProfileService } from '@app/shared/services/dna-profile.service';
import {
  loadRolesThatFit,
  loadRolesThatFitError,
  loadRolesThatFitSuccess,
} from './roles-that-fit.actions';
import { RoleThatFits } from '@app/modules/authenticated-view/modules/vanguard-view/dna-profile/models/dna-profile.model';

// Set to false to fetch real data from the BE roles-that-fit endpoint.
export const USE_ROLES_THAT_FIT_MOCK = true;

const MOCK_ROLES_THAT_FIT: RoleThatFits[] = [
  {
    id: '1',
    title: 'Senior MSL, Oncology',
    location: 'Seattle, WA',
    department: 'Medical Affairs',
    fitSentence:
      'You have six years in oncology field medical and presented cancer genomics to 40+ oncologists.',
    jobUrl: '',
  },
  {
    id: '2',
    title: 'Field Medical Director, Diagnostics',
    location: 'San Francisco, CA',
    department: 'Medical Affairs',
    fitSentence:
      'Matches your experience as a Medical Science Liaison and your skills in companion diagnostics and KOL engagement.',
    jobUrl: '',
  },
  {
    id: '3',
    title: 'Scientific Communications Manager',
    location: 'Cambridge, MA',
    department: 'Medical Communications',
    fitSentence: 'Matches your skills in scientific presentation and congress planning.',
    jobUrl: '',
  },
];

@Injectable()
export class RolesThatFitEffects {
  private actions$ = inject(Actions);
  private dnaProfileService = inject(DnaProfileService);

  loadRolesThatFit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRolesThatFit),
      switchMap(({ id }) => {
        if (USE_ROLES_THAT_FIT_MOCK) {
          return of(loadRolesThatFitSuccess({ roles: MOCK_ROLES_THAT_FIT }));
        }
        return this.dnaProfileService.getRolesThatFit(id).pipe(
          map((roles) => loadRolesThatFitSuccess({ roles })),
          catchError((error) => of(loadRolesThatFitError({ error }))),
        );
      }),
    ),
  );
}
